import { render, staticRenderFns } from "./Reportes.vue?vue&type=template&id=10601b0e"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports